import { format } from 'date-fns';

const dateAtTime = (value, def = '') => {
  if (!value) {
    return def || '';
  }
  const myDate = typeof value === 'string' ? new Date(value) : value;
  return `${format(myDate, 'MM/dd/yyyy')} at ${format(myDate, 'h:mm a')}`;
};

export default dateAtTime;
